import { render, staticRenderFns } from "./customersReport.vue?vue&type=template&id=544198c1&"
import script from "./customersReport.vue?vue&type=script&lang=js&"
export * from "./customersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports